<!-- Zweck: Stellt die HTML-Struktur für user menu component im Frontend bereit. -->
<mat-menu #userMenu="matMenu" class="user-menu">
  @if (domaincfg.show_customer_numbers && lieferkunde) {
    <button mat-menu-item class="tut_lieferkunde_button" style="height: auto; white-space: normal;" routerLink="/lieferkunden"
      >
      <table>
        <tr>
          <td style="vertical-align: middle; line-height: 18px">
            <svg-icon>lieferadresse</svg-icon>
          </td>
          <td style="line-height: 18px; padding-left: 5px">
            <strong>{{lieferkunde.Vorname}}</strong>
            <br><br>
            @if (domaincfg.showA2KndNrOverwrite == 'A2KndNrDefault') {
              {{lieferkunde.A2KndNrDefault}}
            }
            @if (domaincfg.showA2KndNrOverwrite == 'A2KndNrOrganisationseinheit') {
              {{lieferkunde.A2KndNr}}
            }
            @if (domaincfg.showA2KndNrOverwrite == 'Nein') {
              {{lieferkunde.LieferkundeNr}}
            }
            <br>
              {{lieferkunde.Nachname}}
              <br>
                <small>{{lieferkunde.Strasse|trim}}, {{lieferkunde.Plz}} {{lieferkunde.Ort}}</small>
              </td>
            </tr>
          </table>
        </button>
      }
      @if (!domaincfg.show_customer_numbers && lieferkunde) {
        <button mat-menu-item class="tut_lieferkunde_button" routerLink="/lieferkunden"
          >
          <table>
            <tr>
              <td style="vertical-align: middle; line-height: 18px">
                <svg-icon>lieferadresse</svg-icon>
              </td>
              <td style="line-height: 18px; padding-left: 5px">
                <strong>{{lieferkunde.Vorname}}</strong>
                <br><br>
                {{lieferkunde.Nachname}}
                <br>
                  <small>{{lieferkunde.Strasse|trim}}, {{lieferkunde.Plz}} {{lieferkunde.Ort}}</small>
                </td>
              </tr>
            </table>
          </button>
        }

        <permission-block [oneOfRoles]="['Kundeneinstellungen']">
          @if (lieferkunde) {
            <button routerLink="/customer-settings" mat-menu-item title="Kunden-Einstellungen ändern">
              <svg-icon>einstellungen</svg-icon>
              Kunden-Einstellungen
            </button>
          }
        </permission-block>

        @if (lieferkunde) {
          <button routerLink="/settings" mat-menu-item title="Benutzer-Einstellungen ändern">
            <svg-icon>einstellungen</svg-icon>
            Benutzer-Einstellungen
          </button>
        }

        @if (user.impersonated_by) {
          <button mat-menu-item (click)="depersonate()" title="Depersonate">
            <svg-icon>logout</svg-icon>
            Depersonate
          </button>
        }
        @if (user.hasRole('Readonly-Impersonate') && !user.impersonated_by) {
          <button mat-menu-item (click)="startReadOnlyImpersonation()" title="Read-only-Impersonation starten">
            <svg-icon>benutzer</svg-icon>
            Read-only-Impersonation starten
          </button>
        }

        @if (lieferkunde) {
          <button (click)="restart()" mat-menu-item title="Neustarten">
            <svg-icon>neustart</svg-icon>
            Neustarten
          </button>
        }

        <button mat-menu-item routerLink="/logout" title="Abmelden">
          <svg-icon>logout</svg-icon>
          Abmelden
        </button>
      </mat-menu>
      @if (isMobile|async) {
        <br>
        }
        @if (user.hasRole('Admin')) {
          <button mat-button routerLinkActive="active" routerLink="/admin" title="Admin">
            <svg-icon>admin</svg-icon>
          </button>
        }
        <button [matMenuTriggerFor]="userMenu" class="tut_user_menu" mat-button [class.color_orange]="differential_lieferkunde"
          style="vertical-align: middle">
          @if (user.vertreter) {
            <svg-icon>vertreter</svg-icon>
          }
          @if (!user.vertreter) {
            <svg-icon>benutzer</svg-icon>
          }
          @if (user) {
            <span>{{user.benutzerandruckname}}</span>
          }
        </button>

